<template>
  <booking-form
    ref="form"
    :property-mutator="propertyMutator"
    :in-person-opportunity-options="inPersonOpportunityOptions"
    :online-opportunity-options="onlineOpportunityOptions"
    :category-options="categoryOptions"
    :booking="booking"
    :duplicated="duplicated"
    :validationTriggered="validationTriggered"
    :additional-departments="additionalDepartments"
  >
    <template slot="shortlist">
      <slot name="shortlist-parent">
        <request-shortlist
          :booking="booking"/>
      </slot>
    </template>
  </booking-form>
</template>

<script>
import { mapActions } from 'vuex'
import { map } from 'lodash'
import { handleServerErrors } from 'utils'
import BookingForm from '../misc/BookingForm'
import RequestShortlist from './request/RequestShortlist'

export default {
  props: {
    propertyMutator: {
      required: true,
      type: Function
    },
    booking: {
      required: true,
      type: Object
    },
    validationTriggered: {
      required: true,
      type: Boolean
    },
    duplicated: {
      required: false,
      type: Boolean,
      default: false
    },
    additionalDepartments: {
      required: false,
      default: []
    }
  },

  components: {
    BookingForm,
    RequestShortlist
  },

  data () {
    return {
      inPersonOpportunityOptions: [],
      onlineOpportunityOptions: [],
      categoryOptions: []
    }
  },

  created () {
    this.getOpportunities({ level: 'parent', type: 'in_person' })
      .then(({ data }) => {
        this.inPersonOpportunityOptions = this.mapOpportunitiesResponseForSelectize(data)
      })

    this.getOpportunities({ level: 'parent', type: 'online' })
      .then(({ data }) => {
        this.onlineOpportunityOptions = this.mapOpportunitiesResponseForSelectize(data)
      })

    if (this.$categoryModuleEnabled) {
      this.getCategories().then(({ data }) => {
        this.categoryOptions = this.mapOpportunitiesResponseForSelectize(data)
      })
    }
  },

  methods: {
    ...mapActions('opportunity', ['getOpportunities']),
    ...mapActions('category', ['getCategories']),

    mapOpportunitiesResponseForSelectize (opportunities) {
      return map(opportunities, (opportunity) => ({ id: opportunity.id, text: opportunity.name, currency: opportunity.currency }))
    },

    validate () {
      return Promise.all([this.$refs.form.validate()])
    },

    /**
     * Inject server errors into the booking form. Error will be an exception.
     *
     * @return void
     */
    injectServerErrors (error) {
      handleServerErrors(error, this.$refs.form.errors)
    }
  }
}
</script>
